// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import featureFlags from "global/feature-flags"
import withConnect from "hoc/withConnect"
import Page from "pages/_Page"
import MainFilter from "pages/_Page/MainFilter"
import IntroMessage from "components/IntroMessage"
import PlanBanner from "components/PlanBanner"
import { Space } from "componentsStyled/Layout/Spacers"
import { selectAppConfig, selectActivity, selectProductGroups, selectGeolocation } from "data/app/selectors"
import { selectSearchParams } from "data/search/selectors"
import { getPlan } from "data/plans/helpers"
import UpcomingReservations from "./UpcomingReservations"
import NearbyStores from "./NearbyStores"
import NearbyProducts from "./NearbyProducts"
import withUser from "hoc/withUser"

const ProductsPage = ({ appConfig, activity, geolocations, productGroups, params, ...props }) => {
  const user = props.user;
  const plan = featureFlags.showPassportUpsellInProductsPage() ? getPlan("Passport") : getPlan("Perks")
  const showUpsells = featureFlags.showSubscriptionUpsellInProductsPage()

  return (
    <Page
      filter={MainFilter}
      message={(appConfig && !appConfig.hideStores) ? IntroMessage : Space}
    >
      {user && <UpcomingReservations />}
      {plan && showUpsells && <PlanBanner plan={plan} />}
      {(appConfig && !appConfig.hideStores) ?
        <NearbyStores productGroups={productGroups} geolocations={geolocations} params={params} />
        :
        <Space />
      }
      <NearbyProducts productGroups={productGroups} geolocations={geolocations} />
    </Page>
  )
}

const mapStateToProps = state => ({
  appConfig: selectAppConfig(state),
  activity: selectActivity(state),
  productGroups: selectProductGroups(state),
  geolocations: selectGeolocation(state),
  params: selectSearchParams(state),
})

const enhancer: HOC<*, {||}> = compose(
  withUser(),
  withConnect(mapStateToProps)
)

export default enhancer(ProductsPage)



// WEBPACK FOOTER //
// ./src/pages/Products/index.js